module.exports = __webpack_public_path__ + "img/technology_icon_06.f876388c.png";